const TENANT_STORAGE_KEY = 'funnels:selected-tenant-id'
const TENANT_CHANGE_EVENT = 'funnels:tenant-changed'

export function getSelectedTenantId(): string {
  if (typeof window === 'undefined') return import.meta.env.VITE_FUNNELS_TENANT_ID || import.meta.env.VITE_TENANT_ID || ''
  return window.localStorage.getItem(TENANT_STORAGE_KEY) || import.meta.env.VITE_FUNNELS_TENANT_ID || import.meta.env.VITE_TENANT_ID || ''
}

export function setSelectedTenantId(tenantId: string): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(TENANT_STORAGE_KEY, tenantId)
  window.dispatchEvent(new CustomEvent(TENANT_CHANGE_EVENT, { detail: tenantId }))
}

export function subscribeTenantChanges(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => {}

  const handler = () => callback()
  window.addEventListener(TENANT_CHANGE_EVENT, handler)
  window.addEventListener('storage', handler)
  return () => {
    window.removeEventListener(TENANT_CHANGE_EVENT, handler)
    window.removeEventListener('storage', handler)
  }
}

export function resolveTenantId(fallbackTenantId?: string): string {
  const selectedTenantId = getSelectedTenantId()
  if (selectedTenantId) return selectedTenantId
  return fallbackTenantId ?? ''
}
